<template>
  <svg :style="style" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Mask group">
      <mask id="mask0_3735_78487" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="32">
        <rect id="Rectangle 34624919" width="32" height="32" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_3735_78487)">
      </g>
      <g id="Frame">
        <path id="Vector"
          d="M3.91953 14.1867C3.8662 14.5334 4.1062 14.8267 4.45286 14.88C5.67953 15.0934 7.33286 15.44 8.71953 15.8134C10.2129 16.24 11.1195 17.5467 12.5062 17.92C13.8929 18.2934 15.5195 17.1734 15.5195 15.6C15.5195 14.6134 14.6929 12.4267 15.9462 11.28C17.2262 10.16 17.2795 8.64003 16.1595 7.92003C14.2129 6.6667 12.5329 7.89336 10.6662 8.24003C8.61286 8.61336 6.93286 8.16003 5.43953 7.7867C5.09286 7.7067 4.77286 7.9467 4.71953 8.2667L3.91953 14.1867ZM28.0795 22.1334C28.3195 21.8934 28.2929 21.52 28.0529 21.28C27.1729 20.4 25.2529 18.2934 24.9329 17.8134C23.4662 15.76 23.4662 13.4134 22.5595 12.32C21.6795 11.2267 22.6662 13.4934 21.2795 14.3467C20.0529 15.0934 18.5062 14.7467 17.6529 17.04C16.8795 19.0934 14.6929 18.3734 15.4129 19.68C16.5062 21.7067 18.2129 21.4934 19.8662 22.2667C21.7329 23.1467 22.8529 24.5067 23.8662 25.68C24.0795 25.9467 24.5062 25.92 24.7195 25.7067L28.0795 22.1334ZM18.3462 8.77336C18.5329 9.17336 18.7995 10.2934 18.3462 11.0934C17.8662 11.9467 17.5729 12.9867 17.9195 13.3334C18.2662 13.68 19.5995 13.36 19.9195 12.8C20.2395 12.24 19.9195 11.28 20.1862 10.9867C20.4529 10.6934 21.8129 10.6934 21.8929 10.24C21.9729 9.7867 20.4795 8.53336 19.4929 8.32003C18.5062 8.13336 18.1595 8.37336 18.3462 8.77336Z"
          :fill="color" />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'icon-gk',
  props: {
    fontSize: {
      type: String,
      default: '18px'
    },
    color: {
      type: String,
      default: 'white'
    }
  },
  data() {
    return {
      style: {
        width: '1em',
        height: '1em',
        'vertical-align': 'middle',
        fill: 'currentColor',
        overflow: 'hidden',
        cursor: 'pointer',
        'font-size': this.fontSize
      }
    }
  }
}
</script>